import { render, staticRenderFns } from "./booking-edit-services.vue?vue&type=template&id=c2d99fd4&"
import script from "./booking-edit-services.vue?vue&type=script&lang=js&"
export * from "./booking-edit-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports